const moduleName = '.options'

export default ({
  clientWrapper,
  context
}) => ({
  fetchSuggestions: (field, query) => {
    context.lastApiPath = 'no_notificate'
    return clientWrapper.api.get(`/options/suggestions/${field}`, {
      params: {
        q: query
      }
    })
  },

  fetchStaticOptions: (field, source = 'app_config') => {
    context.lastApiPath = `${moduleName}.fetchStaticOptions`
    return clientWrapper.api.get(`/options/select/${field}`, { params: { source }})
  },

  fetchDynamicOptions: (filter, field) => {
    context.lastApiPath = `${moduleName}.fetchDynamicOptions`
    return clientWrapper.api.get(`/options/filtered/${field}`, {
      params: { filter: 'brand', q: filter }
    })
  },

  fetchRichOptions: (selectName) => {
    context.lastApiPath = `${moduleName}.fetchRichOptions`
    return clientWrapper.api.get(`/options/rich_select/${selectName}`)
  },

  fetchMagazines: () => {
    context.lastApiPath = `${moduleName}.fetchMagazines`
    return clientWrapper.api.get('/options/select/magazines')
  },

  fetchCollections: () => {
    context.lastApiPath = `${moduleName}.fetchCollections`
    return clientWrapper.api.get('/options/select/collections')
  },

  fetchCountries: () => {
    context.lastApiPath = `${moduleName}.fetchCountries`
    return clientWrapper.api.get('/options/select/countries')
  },
})
